import type { CycleEvaluationGroupStepsType } from '@/constants/cycle-evaluation/CycleEvaluationGroupSteps';

import { CycleEvaluationGroupSteps } from '@/constants/cycle-evaluation/CycleEvaluationGroupSteps';

/**
 * Steps with a renderable page — restated as plain data to avoid importing the registry
 * (circular import). Drift is guarded by `cycleEvaluationGroupStepComponents.test.ts`.
 */
export const CYCLE_EVALUATION_GROUP_RENDERABLE_STEPS: readonly CycleEvaluationGroupStepsType[] = [
    CycleEvaluationGroupSteps.CYCLE_INFORMATION,
    CycleEvaluationGroupSteps.EVALUATION_ELEMENTS,
    CycleEvaluationGroupSteps.FEEDBACK_360_SETTINGS,
    CycleEvaluationGroupSteps.DEADLINES,
    CycleEvaluationGroupSteps.COMMUNICATIONS,
];
